import './GuiThemesTableItem.scss'
import {ReactComponent as MenuOnHover} from "../../../../../../../../assets/flyersScreen/3_dots_icon.svg";
import {ReactComponent as CameraIcon} from "../../../../../../../../assets/camera_icon.svg";

// import editIcon from '../../../../../../../../assets/edit_icon.png'
// import xIcon from '../../../../../../../../assets/x_icon.png'

import {GuiSettingsDto, ItemsListMenuDto} from '../../../../../../../../dtos'
import {Box, Button, Typography} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {AsyncImageWithLoader} from "../../../../../../../../com/imageWithLoader/imageWithLoader";
// import {ReactComponent as ImageWithError} from "../../../../../../../../assets/promos&items/image_error.svg";
import React, {useEffect, useRef, useState} from "react";
import {
    MenuForPromotion
} from "../../../../../../promos/leftMenu/LeftMenuContent/LeftMenuContentElement/MenuForPromotions/menuForPromotions";
import {getIconStyle} from "../../../../../../../../globals/globFunctions";

const useStyle = makeStyles(() => ({
    cellBox: {
        height: `100%`,
        display: `flex`,
        alignItems: `center`,
        justifyContent: `center`
    },
    iconWrapper: (props: any) => ({
        width: `32px`,
        height: `32px`,
        maxWidth: `32px`,
        maxHeight: `32px`,
        borderRadius: "50%",
        // backgroundColor: "#ffffff",
        // border: `1px solid #E2E2E2`,
        margin: `4px 0`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "& > svg > rect": {
            fill: ((props.iconStyleType === 2 || props.iconStyleType  === 3) && props.mainColor) && props.mainColor
        }
    })
}))

interface IGuiThemesTableItem {
    rowIndex: number;
    dto: GuiSettingsDto;
    onEdit: (rowIndex: number, dto: any) => void;
    onDelete: (rowIndex: number, dto: any) => void;
    isCloseMenu: boolean;
    setIsCloseMenu: (value: boolean) => void;
}

const GuiThemesTableItem: React.FC<IGuiThemesTableItem> = (props) => {
    const anchorRefForGUIMenu = useRef(null);
    const [isOpenedGUIMenu, setOpenGUIMenu] = useState(false);
    const [isHoverOnUnlinkPromoAndItem, changeStatusForUnlinkPromoAndItem] = useState<boolean>(false);
    const prevOpenGUIMenu = useRef(isOpenedGUIMenu);
    const iconStyleData = getIconStyle(props.dto.gusIconContrast || 1);
    const IconComponent = iconStyleData.iconStyleData.promoCompIcon;
    const properties = {
        iconStyleType: iconStyleData.iconStyleType,
        mainColor: props.dto.gusPrimaryColorRgb
    }
    const classes = useStyle(properties);
    useEffect(() => {
        props.setIsCloseMenu(!isOpenedGUIMenu);
    }, [isOpenedGUIMenu]);


    useEffect(() => {
        if(props.isCloseMenu && isOpenedGUIMenu){
            setOpenGUIMenu(!isOpenedGUIMenu);
        }
    }, [props.isCloseMenu]);

    let logoIcon: string | null = null
    if (props && props.dto && props.dto.gusLogoUrl) {
        logoIcon = props.dto.gusLogoUrl;
    }

    const handleToggleForFlyer = () => {
        setOpenGUIMenu((prevOpen) => !prevOpen);
    };

    const clickMenuDataForFlyer: ItemsListMenuDto = {
        setOpen: setOpenGUIMenu,
        prevOpen: prevOpenGUIMenu,
        open: isOpenedGUIMenu,
        anchorRef: anchorRefForGUIMenu,
    };

    const onDeleteGui = () => {
        if (props.dto.isDeleteable) {
            props.onDelete(props.rowIndex, props.dto);
            onMouseLeavePromo();
        }
    }
    const onEditGui = () => {
        props.onEdit(props.rowIndex, props.dto);
        onMouseLeavePromo()
    }

    const onMouseEnterPromo = () => {
        changeStatusForUnlinkPromoAndItem(true);
    }

    const onMouseLeavePromo = () => {
        changeStatusForUnlinkPromoAndItem(false);
        setOpenGUIMenu(false);
    }

    return (
        <tr className={`${isHoverOnUnlinkPromoAndItem ? "onHoverEffect" : ""} gui_themes_table_item`} key={1}
            onMouseEnter={onMouseEnterPromo}
            onMouseLeave={onMouseLeavePromo}
        >
            <td>
                <Box className={classes.cellBox}>
                    <Typography>
                        {props.dto.gusCaption}
                    </Typography>
                </Box>
            </td>
            <td>
                <Box className={classes.cellBox} sx={{
                    backgroundColor: props.dto.gusPrimaryColorRgb ? props.dto.gusPrimaryColorRgb : '#ffffff'
                }}>
                    <Box sx={{
                        width: `100%`,
                        height: `50px`,
                        maxWidth: `100%`,
                        maxHeight: `50px`,
                        display: `flex`,
                        alignItems: `center`,
                        justifyContent: `center`,
                        margin: `0 5px`
                    }}>
                        {
                            logoIcon &&
                            <AsyncImageWithLoader
                                src={logoIcon ? logoIcon : 'https://'}
                                notUploadIcon={(<CameraIcon/>)}
                            />
                        }
                    </Box>
                </Box>
            </td>
            <td>
                <Box className={classes.cellBox}>
                    <Box sx={{width: `20px`, height: `20px`}}>
                        <div className="gui_themes_table_item_color" style={{
                            backgroundColor: props.dto.gusPrimaryColorRgb ? props.dto.gusPrimaryColorRgb : '#0000FF'
                        }}/>
                    </Box>
                </Box>
            </td>
            <td>
                <Box className={classes.cellBox}>
                    <Typography fontFamily={props.dto.gusFont?.toLowerCase()} fontSize={`14px`}>
                        {
                            props.dto.gusFont === 'OpenSans' ?
                                'Open Sans' :
                                (
                                    props.dto.gusFont === 'AlmoniTzar' ?
                                        'Almoni Tzar (Hebrew)' :
                                        (
                                            props.dto.gusFont === 'OpenSansHeb' ?
                                                'Open Sans (Hebrew)' :
                                                props.dto.gusFont
                                        )
                                )
                        }
                    </Typography>
                </Box>
            </td>
            <td>
                <Box className={classes.cellBox}>
                    <Box sx={{
                        width: `50px`,
                        height: `50px`,
                        maxWidth: `50px`,
                        maxHeight: `50px`,
                        border: `1px solid #E2E2E2`,
                        margin: `5px 0`,
                        borderRadius: `5px`,
                        backgroundColor: "#ffffff"
                    }}>
                        {
                            props.dto.gusBackgroundImageUrl && !Boolean(props.dto.gusBackgroundColorRgb)
                                ? <AsyncImageWithLoader
                                    src={props.dto.gusBackgroundImageUrl}
                                    notUploadIcon={(<CameraIcon/>)}
                                />
                                : <div style={{
                                    backgroundColor: props.dto.gusBackgroundColorRgb ? props.dto.gusBackgroundColorRgb : '#ffffff',
                                    height: `100%`,
                                    width: `100%`,
                                    borderRadius: `5px`,
                                }}/>

                        }
                    </Box>
                </Box>
            </td>
            <td>
                <Box className={classes.cellBox}>
                    <Box className={classes.iconWrapper}>
                        <IconComponent style={{width: "100%", height: "100%"}}/>
                    </Box>
                </Box>
            </td>
            <td>
                {isHoverOnUnlinkPromoAndItem &&
                    <Box
                        className={`${classes.cellBox}`}
                    >
                        <Button
                            sx={{
                                width: "24px",
                                height: "24px",
                                "&:hover": {
                                    backgroundColor: "#88888833"
                                }
                            }}
                            ref={anchorRefForGUIMenu}
                            aria-controls={
                                isOpenedGUIMenu
                                    ? "menu-list-grow"
                                    : undefined
                            }
                            aria-haspopup="true"
                            onClick={handleToggleForFlyer}
                        >
                            <MenuOnHover style={{pointerEvents: "none"}}/>
                        </Button>
                        <MenuForPromotion
                            list={clickMenuDataForFlyer}
                            deleteGui={onDeleteGui}
                            // handleDeleteClick={userDto.accountTier === 1 ? handleDeleteClick : softDeleteFlyer}
                            editGui={onEditGui}
                            infoForMenu={`menuForGui`}
                            isDisableDelete={!props.dto.isDeleteable}
                        />
                    </Box>
                }
            </td>
        </tr>
    )
}

export default GuiThemesTableItem